import React from "react";
import "./plantAssistant.css";

/**
 * Coco's face: the COCO AI Assistant logo, drawn inline so it scales to any size
 * without an extra request. The tile (border, tilt, shadow) comes from .pa-logo
 * plus a size class such as pa-logo-sm (plantAssistant.css). The navbar link uses
 * it outside the assistant, hence the stylesheet import here.
 */
export default function CocoLogo({ className = "" }) {
  return (
    <span className={`pa-logo ${className}`.trim()} aria-hidden="true">
      <svg viewBox="0 0 280 280" focusable="false">
        <rect width="280" height="280" fill="#71ae12" />
        <g transform="translate(40 40)">
          <rect width="200" height="200" fill="#d5a276" />
          <path d="M0,0 H200 V102 L140,68 L124,88 L0,92 Z" fill="#201e1d" />
          <path d="M46,108 L76,106" stroke="#201e1d" strokeWidth="7" fill="none" />
          <path d="M124,104 L156,92" stroke="#201e1d" strokeWidth="7" fill="none" />
          <rect x="54" y="120" width="13" height="13" fill="#201e1d" />
          <rect x="128" y="126" width="24" height="7" fill="#201e1d" />
          <path d="M78,156 L118,156 L136,142" stroke="#201e1d" strokeWidth="8" fill="none" strokeLinejoin="miter" />
        </g>
      </svg>
    </span>
  );
}
